<mat-form-field
  [appearance]="model.getAdditional('appearance', 'outline')"
  [color]="model.getAdditional('color', 'primary')"
  [formGroup]="group"
  [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
  [ngClass]="getClass('grid', 'control')"
>
  <ng-container *ngIf="model.label" ngProjectAs="mat-label">
    <mat-label
      *ngIf="model.getAdditional('showLabelOnInit', true) ? true : isFocus"
      [innerHTML]="model.label"
    ></mat-label>
  </ng-container>

  <textarea
    matInput
    [cdkTextareaAutosize]="model.getAdditional('cdkTextareaAutosize', true)"
    [cdkAutosizeMinRows]="model.getAdditional('cdkAutosizeMinRows', '3')"
    [cdkAutosizeMaxRows]="model.getAdditional('cdkAutosizeMaxRows', '3')"
    [cols]="model.cols"
    [formControlName]="model.id"
    [id]="id"
    [maxlength]="model.maxLength"
    [minlength]="model.minLength"
    [name]="model.name"
    [ngClass]="getClass('element', 'control')"
    [placeholder]="model.placeholder"
    [readonly]="model.readOnly"
    [required]="model.required"
    [rows]="model.rows"
    [spellcheck]="model.spellCheck"
    [tabindex]="model.tabIndex"
    [wrap]="model.wrap"
    (blur)="onBlur($event); checkInput(model.value)"
    (change)="onChange($event); checkInput(model.value)"
    (focus)="onFocus($event); ifFocus($event)"
  ></textarea>

  <mat-hint *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>

  <mat-hint *ngIf="showCharacterHint" align="end">{{ characterHint }}</mat-hint>

  <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
</mat-form-field>
